export const mobileLayoutNav = [
  {
    navigation: [
      {
        navId: 1,
        label: "Payment",
        path: "/payment-receipt-responsive",
      },
      {
        navId: 2,
        label: "Customer",
        path: "/customer-responsive",
      },
      {
        navId: 3,
        label: "Sales Order",
        path: "/sales-order-responsive",
      },
      {
        navId: 4,
        label: "Sales Return",
        path: "/sales-return-responsive",
      },
      // {
      //   navId: 5,
      //   label: "Stock Dashboard",
      //   path: "/",
      // },
    ],

    reports: [
      {
        navId: 1,
        label: "Check-In Dashboard",
        path: "/check-in-dashboard-responsive",
      },
      // {
      //   navId: 2,
      //   label: "Daily Sales",
      //   path: "/",
      // },
      // {
      //   navId: 3,
      //   label: "Daily Sales Return",
      //   path: "/",
      // },
      // {
      //   navId: 4,
      //   label: "Cheque Receipt by Rep",
      //   path: "#",
      // },
      // {
      //   navId: 5,
      //   label: "Back to Main",
      //   path: "#",
      // },
    ],
  },
];
